import { useAtomValue } from 'jotai';
import React from 'react';

import { tvGuideRecordingStatusUpdatesAtom } from '@smart-tv/atoms';
import RecordingAnimation from '@smart-tv/components/recording-animation/recording-animation';
import { ContentItem } from '@smart-tv/typings/content';

interface Props {
  className?: string;
  contentItem: ContentItem;
}

const ContentItemRecordingAnimation: React.FC<Props> = ({ className, contentItem }) => {
  const recordingStatusUpdates = useAtomValue(tvGuideRecordingStatusUpdatesAtom);
  const { eventId, recording, sid } = contentItem;
  const updatedRecordingStatus =
    sid === undefined || eventId === undefined
      ? undefined
      : recordingStatusUpdates.programs[`${sid}:${eventId}`]?.isRecording;

  if (!(updatedRecordingStatus ?? recording)) {
    return null;
  }

  return <RecordingAnimation className={className} />;
};

export default React.memo(ContentItemRecordingAnimation);
